<template>
  <div>
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />
    <div class="row">
      <p class="col-4 pt-4">
        Titel der Region
      </p>
      <v-text-field
        v-model="title"
        class="col-6"
      />
    </div>
    <div class="row">
      <p class="col-4 pt-4">
        Geltungsbereich
      </p>
      <u-tree-view
        v-model="selectedLocations"
        class="col-8 pt-4"
        :tree-view-items="locationOptions"
        item-key="path"
        item-text="name"
      />
    </div>
    <div class="row">
      <v-btn
        :disabled="!selectedLocations.length || !title"
        class="btn-left"
        color="success"
        raised
        @click="savePublicholidayRegion"
      >
        <i class="fas fa-plus mr-3" /> Neu Erfassen
      </v-btn>

      <v-btn
        color="#e72b37"
        raised
        style="color: white"
        @click="cancel"
      >
        <i class="fas fa-ban mr-3" /> Abbrechen
      </v-btn>
    </div>
  </div>
</template>

<script>
import UTreeView from "@/components/common/UTreeView.vue";
import { CreatePublicHolidayRegion } from "@/services/minimum.wage.services/publicholidayRegions.minimum.wage";

export default {
  components: {
    UTreeView,
  },
  props: {
    locationOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      errorObject: "",
      title: "",
      selectedLocations: [],
    };
  },
  methods: {
    savePublicholidayRegion() {
      this.isLoading = true;
      var publicHolidayRegion = {
        id: 0,
        title: this.title,
        locations: [],
      };

      publicHolidayRegion.locations = this.selectedLocations.map((location) => {
        return {
          id: 0,
          path: location,
        };
      });
      CreatePublicHolidayRegion(
        publicHolidayRegion,
        () => {
          this.isLoading = false;
          this.clearInputs();
          this.$emit("created");
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    cancel() {
      this.clearInputs();
      this.$emit("cancel");
    },
    clearInputs() {
      this.errorObject = "";
      this.title;
      this.selectedLocations = [];
    },
  },
};
</script>

<style scoped>
/* Your component styles here */
</style>
